var exports = {
  "Lw": "ProfileFrameOverlay.module__overlay___QWtBWH",
  "fV": "ProfileFrameOverlay.module__piece___QWtBWH",
  "Mn": "ProfileFrameOverlay.module__top___QWtBWH",
  "sQ": "ProfileFrameOverlay.module__bottom___QWtBWH",
  "a2": "ProfileFrameOverlay.module__full___QWtBWH",
  "$_": "ProfileFrameOverlay.module__media___QWtBWH",
  "e$": "ProfileFrameOverlay.module__overlayPopout___QWtBWH",
};

module.exports = exports;
